import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const PROVIDERS_PROVIDER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/providers',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:Providers',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.Providers',
      },
    ]);
  };
}
